import { CompactCreateSourceEventAsync } from 'crm-events/createSource';
import TimelineCard from '../generic/TimelineCard';
import { SubjectDependency } from 'crm-events-data';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { jsx as _jsx } from "react/jsx-runtime";
export const dependencies = {
  subject: SubjectDependency
};
const TimelineSourceEventWrapper = ({
  objectType,
  subjectId,
  timelineItem
}) => {
  const subject = useStoreDependency(dependencies.subject, {
    objectType,
    subjectId
  });
  return /*#__PURE__*/_jsx(TimelineCard, {
    objectType: objectType,
    subject: subject,
    subjectId: subjectId,
    TimelineEventComponent: CompactCreateSourceEventAsync,
    timelineItem: timelineItem
  });
};
export default TimelineSourceEventWrapper;